import { Component, inject, OnInit } from '@angular/core';
import { CalendarsListStateService } from '@modules/calendar-app/services/calendars-list-state.service';
import { CalendarsService } from '@modules/calendar-app/services/calendars.service';
import { Calendar } from '@modules/calendar-app/types/calendar';
import { CalendarsFilters } from '@modules/calendar-app/types/calendars-filters';
import { CalendarsListState } from '@modules/calendar-app/types/calendars-list-state';
import { SortOrder } from '@modules/common/types/sort-order';
import { KnowledgeStitchSectionComponent } from '../stitch-section/stitch-section.component';

@Component({
  selector: 'app-knowledge-calendars-section',
  templateUrl: './calendars-section.component.html',
  styleUrls: ['../stitch-section/stitch-section.component.less'],
  standalone: false,
  providers: [
    ...CalendarsListStateService.providers({
      defaultSort: {
        by: 'score',
        order: SortOrder.DESC,
      },
    }),
  ],
})
export class KnowledgeCalendarsSectionComponent
  extends KnowledgeStitchSectionComponent<Calendar, CalendarsFilters>
  implements OnInit
{
  protected readonly listStateService = inject(CalendarsListStateService, { self: true });
  protected readonly stitchService = inject(CalendarsService);

  public override ngOnInit(): void {
    this.state = new CalendarsFilters({ withEmpty: true });
    super.ngOnInit();
  }

  public handleFilter(listState: CalendarsListState): void {
    this.filterChange.emit();

    // Read directly, not streamed: handleFilter only runs on a user action, which is always after
    // the space settings have loaded, so the zone is already the account's (SBUX-829).
    this.filters = new CalendarsFilters({ displayTimeZone: this.displayTimeZoneService.timeZone() });
    this.filters.applyListState(listState);

    this.updateFilters();
  }
}
